export const validators = {
  required: (value) => ({
    isValid: value && value.trim().length > 0,
    message: 'Este campo es requerido'
  }),

  email: (value) => ({
    isValid: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
    message: 'Email inválido'
  }),

  phone: (value) => ({
    isValid: /^(\+?\d{1,3}[-.]?)?\d{4,}$/.test(value.replace(/\s/g, '')),
    message: 'Teléfono inválido'
  }),

  minLength: (min) => (value) => ({
    isValid: value && value.trim().length >= min,
    message: `Debe contener al menos ${min} caracteres`
  }),

  maxLength: (max) => (value) => ({
    isValid: !value || value.trim().length <= max,
    message: `No debe exceder ${max} caracteres`
  }),

  // Anti-bot validation rules
  noRepeatedChars: (value) => ({
    isValid: !value || !/(.)\1{5,}/.test(value),
    message: 'Evita caracteres repetitivos excesivos'
  }),

  noSpamKeywords: (value) => {
    const spamWords = [
      'buy now', 'click here', 'make money', 'viagra', 'casino',
      'lottery', 'winner', 'urgent', 'act now', 'bitcoin', 'crypto'
    ];
    const hasSpam = value && spamWords.some(word => 
      value.toLowerCase().includes(word)
    );
    return {
      isValid: !hasSpam,
      message: 'El contenido parece ser spam'
    };
  },

  maxLinks: (max = 2) => (value) => {
    const linkCount = (value || '').match(/https?:\/\/[^\s]+/g)?.length || 0;
    return {
      isValid: linkCount <= max,
      message: `No puede contener más de ${max} enlaces`
    };
  },

  humanName: (value) => {
    const isGeneric = value && /^(test|bot|spam|admin|user)\d*$/i.test(value.trim());
    return {
      isValid: !isGeneric,
      message: 'Por favor, usa tu nombre real'
    };
  },

  noTempEmail: (value) => {
    const tempDomains = [
      '@tempmail', '@10minutemail', '@guerrillamail', 
      '@mailinator', '@throwaway', '@temp-mail'
    ];
    const isTemp = value && tempDomains.some(domain => 
      value.toLowerCase().includes(domain)
    );
    return {
      isValid: !isTemp,
      message: 'Por favor, usa un email permanente'
    };
  }
};

export const validateField = (value, rules = []) => {
  for (const rule of rules) {
    const validation = rule(value);
    if (!validation.isValid) {
      return validation.message;
    }
  }
  return '';
};

export const validateForm = (formData, validationRules) => {
  const errors = {};
  let isValid = true;

  Object.keys(validationRules).forEach(field => {
    const error = validateField(formData[field], validationRules[field]);
    if (error) {
      errors[field] = error;
      isValid = false;
    }
  });

  return { isValid, errors };
};